import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

function DriverReviewLightBoxContent(props) {
  const { data, onClose } = props;

  useEffect(() => {
    if (location.href.indexOf('disableDriverReviews=1') === -1) {
      let clearIntervalFn2 = setInterval(() => {
        if (window.driverreviews && props.visible) {
          clearInterval(clearIntervalFn2);
          window.driverreviews.refreshWidgets();
        }
      }, 100);
    }
  }, [data]);

  return (
    <div className="cross-sell-light-box__content cross-sell-light-box-content" style={{ padding: '0 50px 10px' }}>
      {data.manufacturer && data.model && (
        <>
          <div
            className="driverreviews-widget"
            data-manufacturer={data.manufacturer}
            data-model={data.model}
            data-type="combined-review"
            data-show-external-review-link
            data-review-size="5"
          ></div>
        </>
      )}
    </div>
  );
}

DriverReviewLightBoxContent.propTypes = {
  LightBoxVisible: PropTypes.bool.isRequired,
  error: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

export { DriverReviewLightBoxContent };
